module.exports = __webpack_public_path__ + "media/images/thumbs/muscles/ahead6-b94dd661ffc96885ac2cb488aadf67ca.jpg";